"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../material/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _searchresultnav_styles = _interopRequireDefault(require("./searchresultnav_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
//material
// styles

/* ========== ~~~~~~~~~~ EXPORT : SEARCH : SEARCH RESULT NAV ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_searchresultnav_styles.default)(function (props) {
  return _react.default.createElement("div", {
    className: "searchresultnav ".concat(props.classes.searchresultnav)
  }, _react.default.createElement("div", {
    className: 'resultCount'
  }, " ", props.resultsCount, " found"), _react.default.createElement("div", {
    className: 'clearResults'
  }, _react.default.createElement(_index.Link, {
    type: "custom",
    handleClick: function handleClick() {
      return props.clearResults();
    },
    icon: "times-circle"
  })), _react.default.createElement("div", {
    className: "resultnav"
  }, _react.default.createElement("div", {
    className: "arrow previous disabled-".concat(props.currentResult === 1)
  }, _react.default.createElement(_index.Link, {
    type: "custom",
    handleClick: function handleClick() {
      return props.handleResultsNav('prev');
    },
    icon: "angle-left"
  })), _react.default.createElement("div", {
    className: "arrow next disabled-".concat(props.currentResult === props.resultsCount)
  }, _react.default.createElement(_index.Link, {
    type: "custom",
    handleClick: function handleClick() {
      return props.handleResultsNav('next');
    },
    icon: "angle-right"
  }))));
});

exports.default = _default;